import React, { useEffect, useState, useRef } from "react";
import { useMediaQuery } from 'react-responsive';
import TalentSideMenu from "../../components/TalentSideMenu";
import ContentNotification from "./components/ContentNotification";
import NewsList from "./components/NewsList";
import SurveyPopup from "../talent_home/components/SurveyPopup";
import { useNavigate } from "react-router-dom";
import TalentHeader from "components/TalentHeader";
import {
  getListNotification, getListNewsMobile, setCanBackPrevPage,
  setHasMore, setCurrentPageLoading, setIsReloadNews, setNewsCardBookmark, setNewsMobile
} from "reducers/talentHome";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import ConsultingButton from "../../components/ConsultingButton";
import {
  setChatSelected,
  setIsChatting, setIsNewChatFormOtherScreen,
  setIsScout,
  setJobSelected, setMessages,
  setStaffSelected,
  setIsLoadNewListChat,
} from "reducers/chatMessage";
import {formatTimeAgo, toFullWidthNumber} from "utils/format";
import logo from "../../../assets/img/logo_20250311.png"
import logo2x from "../../../assets/img/logo_20250311@2x.png"
import CustomIconButton from "../../components/CustomIconButton";
import InfiniteScroll from "react-infinite-scroll-component";
import { LoadingIcon } from "../../components/Icons";
import Copyright from "../../components/Copyright";
import { MOBILE_SCREEN_WIDTH } from "../../constants/index";
import NewsCard from "./components/NewsCard";

const TalentHome = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const {
    newsMobile, pageSize, totalNews, notifications, isReloadNews,
    pageSizeLoading, currentPageLoading, totalResultsMobile, hasMore,
  } = useSelector((state: any) => state.talentHome);
  const {chatList} = useSelector((state: any) => state.chatMessage);
  const [pageStatus, setPageStatus] = useState("default");
  const [isSurveyOpen, setIsSurveyOpen] = useState(true);
  const navigate = useNavigate();
  const currentUser = useSelector((state: any) => state.currentUser);
  const isMobile = useMediaQuery({ maxWidth: MOBILE_SCREEN_WIDTH });

  /* Action with mobile */
  const fetchNewsMobile = () => {
    const data = {
      page: currentPageLoading,
      pageSize: pageSizeLoading,
    };
    dispatch(getListNewsMobile(data));
  }

  useEffect(() => {
    return () => {
      dispatch(setCurrentPageLoading(1));
      dispatch(setHasMore(true));
      dispatch(setNewsMobile([]));
    }
  }, []);

  useEffect(() => {
    fetchNewsMobile();
    // Get list notification
    dispatch(getListNotification(""));
  }, [isReloadNews]);

  const fetchData = () => {
    setTimeout(() => {
      dispatch(setCurrentPageLoading(parseInt(currentPageLoading) + 1));
      dispatch(setIsReloadNews());
    }, 800);
  }
  /* Action with mobile */

  const handleOpenChat = () => {
    dispatch(setIsChatting(true));
    dispatch(setIsNewChatFormOtherScreen(true));
    dispatch(setIsScout(false));
    dispatch(setStaffSelected({}));
    dispatch(setChatSelected({id: null, chat_type:"new"}));
    dispatch(setJobSelected({}));
    dispatch(setMessages([]));
    if(chatList.length > 0) {
      dispatch(setIsLoadNewListChat(false));
    }
    navigate('/talent/message')
  }

  const goDetail = (id: any) => {
    dispatch(setCanBackPrevPage(true));
    navigate("/talent/news/" + id)
  }

  const handleBookmark = (id) => {
    dispatch(setNewsCardBookmark({id: id, view: "news", requestBody: {}}));
  }

  return (
    <>
      {isSurveyOpen && (
        <SurveyPopup
          open={isSurveyOpen}
          onClose={() => {
            setIsSurveyOpen(false);
            localStorage.setItem("lastSurveyDate", new Date().toISOString());
          }}
        />
      )}
      {pageStatus === "default" ? (
        <TalentHeader
          productNameMob="ホーム" 
          startIcon={{
            icon: (
              <span className="md:hidden">
                <img src={logo}
                  srcSet={`${logo} 1x, ${logo2x} 2x`}
                  alt="aloop logo" 
                  width="103" 
                  height="27"
                />
              </span>
            ),
          }}
        />
      ) : (
        <TalentHeader
          prevPage={{ name: "ホーム", onClick: () => setPageStatus("default") }}
        />
      )}
      <div className="pb-[56px] md:pb-0 md:mt-4 md:px-4 lg:mt-6 lg:px-6 mt-4 block md:flex md:gap-4 lg:gap-6 relative">
        <div className="fixed top-56 right-0 z-[99] hidden md:block">
          <ConsultingButton onClick={handleOpenChat} />
        </div>
        <TalentSideMenu />
        {/* mobile */}
        <div className="flex-1 px-4 md:hidden">
          {notifications?.length > 0 && (
          <>
          <h2 className="text-xl font-bold alu-text-base-2 mb-2">お知らせ</h2>
          <div className="mb-6">
            <ContentNotification />
          </div>
          </>
          )}

          {pageStatus === "default" && (
            <div className="mb-2">
              <h3 className="mb-2 text-xl font-bold alu-text-base-2">
                ニュース
              </h3>
              {isMobile && (
              <InfiniteScroll
                dataLength={newsMobile.length}
                next={fetchData}
                hasMore={hasMore}
                loader={<div className="flex justify-center p-2"><LoadingIcon /></div>}
                scrollThreshold={0.8}
              >
                <div className="flex flex-col gap-4">
                  {newsMobile.map((item: any, idx: any) => (
                    <div
                      key={idx}
                      className="rounded-2xl overflow-hidden bg-white"
                    >
                      <NewsCard items={item} goToDetail={(id) => goDetail(id)} handleBookmark={(id) => handleBookmark(id)} line_option="line-clamp-1" />
                    </div>
                  ))}
                </div>
              </InfiniteScroll>
              )}
            </div>
          )}
          <Copyright view="talent" />
        </div>

        {/* tablet & desktop */}
        <div className="md:block flex-1 hidden">
          {notifications?.length > 0 && (
          <>
          <h2 className="text-xl font-bold alu-text-base-2 mb-2">お知らせ</h2>
          <div className="mb-6">
            <ContentNotification />
          </div>
          </>
          )}

          <h2 className="text-xl font-bold alu-text-base-2 mb-2">ニュース</h2>
          <div>
            <NewsList />
          </div>
        </div>
      </div>
      <div className="hidden md:block">
        <Copyright view="talent" />
      </div>
    </>
  );
};

export default TalentHome;